import React from 'react';
import ModalShell from '../../shared/components/modal/ModalShell';
import ModalFormFooter from '../../shared/components/modal/ModalFormFooter';
import { inputClassName } from '../../shared/components/modal/FormField';
import useFormState from '../../shared/hooks/useFormState';
import { trimData } from '../../shared/lib/formatters';

const TransactionsUpdateModal = ({ isOpen, onClose, transaction, onUpdate }) => {
  const initialValues = React.useMemo(
    () => ({
      status: transaction?.status || 'pending',
      tokens: transaction?.tokens || 0,
    }),
    [transaction]
  );

  const { formData, handleChange, isLoading, setIsLoading, isSubmitDisabled } = useFormState({
    initialValues,
    isOpen,
    mode: 'edit',
  });

  const handleCancel = () => onClose();

  const handleSave = async () => {
    setIsLoading(true);
    try {
      await onUpdate(transaction.id, trimData(formData));
      onClose();
    } finally {
      setIsLoading(false);
    }
  };

  const approved = transaction?.status === 'approved';

  const footer = (
    <ModalFormFooter
      onCancel={handleCancel}
      onSubmit={handleSave}
      isLoading={isLoading}
      isDisabled={isSubmitDisabled}
    />
  );

  if (!transaction) return null;

  return (
    <ModalShell isOpen={isOpen} onClose={handleCancel} title="Approve Transaction" footer={footer} maxWidthClass="max-w-xl">
      <form onSubmit={(e) => e.preventDefault()}>
        <div className="grid grid-cols-2 gap-4">
          <div className="flex flex-col mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">Tokens</label>
            <input
              type="number"
              name="tokens"
              value={formData.tokens ?? ''}
              onChange={handleChange}
              className={inputClassName}
              disabled={approved}
            />
          </div>
          <div className="flex flex-col mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">Status</label>
            <select
              name="status"
              value={formData.status}
              onChange={handleChange}
              className={inputClassName}
              required
              disabled={approved}
            >
              <option value="pending">Pending</option>
              <option value="approved">Approved</option>
            </select>
          </div>
        </div>
      </form>
    </ModalShell>
  );
};

export default TransactionsUpdateModal;
